import React from "react";
import { MdArrowBack } from "react-icons/md";

const Header = ({ patient, onBack }) => {
  return (
    <div className="flex items-center justify-between bg-white p-6 rounded-lg shadow-md border">
      {/* Back Button */}
      <button
        onClick={onBack}
        className="flex items-center text-blue-600 hover:text-blue-700 transition duration-150"
      >
        <MdArrowBack className="text-2xl mr-2" />
        <span className="text-sm font-medium">Back</span>
      </button>

      {/* Workflow Information */}
      <div className="flex flex-col text-center">
        <h1 className="text-2xl font-bold text-gray-800">Discharge Workflow</h1>
        <p className="text-sm text-gray-600 mt-1">
          Patient: <span className="font-semibold">{patient.name}</span>
        </p>
        <p className="text-sm text-gray-600">
          Doctor: <span className="font-semibold">{patient.doctor}</span> |
          Ward: <span className="font-semibold">{patient.ward}</span>
        </p>
      </div>

      {/* Patient Info Summary */}
      <div className="flex flex-col items-end text-right">
        <p className="text-sm text-gray-700">
          <span className="font-medium">Age:</span> {patient.age}
        </p>
        <p className="text-sm text-gray-700">
          <span className="font-medium">Gender:</span> {patient.gender}
        </p>
        <p className="text-sm text-gray-700">
          <span className="font-medium">Bed:</span> {patient.bed}
        </p>
      </div>
    </div>
  );
};

export default Header;
